<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-icon left>assessment</v-icon>
        Reporte de Registro de Expedientes por Usuario
      </v-card-title>

      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="3">
            <v-menu
              v-model="menuFechaDesde"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fecha_desde"
                  label="Fecha desde"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_desde"
                @input="menuFechaDesde = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="menuFechaHasta"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fecha_hasta"
                  label="Fecha hasta"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_hasta"
                @input="menuFechaHasta = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn color="primary" @click="consultar" :loading="loading">
              <v-icon left>search</v-icon>
              Consultar
            </v-btn>
          </v-col>
          <v-col v-if="consultado" cols="12" sm="3">
            <v-btn color="green" dark @click="descargarExcel" :loading="loadingExcel">
              <v-icon left>mdi-file-excel</v-icon>
              Descargar Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-alert v-if="consultado && datos.length === 0" type="info">
          Sin registros para el rango seleccionado.
        </v-alert>

        <div v-if="datos.length > 0">
          <v-card outlined class="mb-4">
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <div class="headline">{{ totalRegistros }}</div>
                  <div class="caption">Total de registros en el rango seleccionado</div>
                </v-col>
                <v-col cols="6">
                  <div class="headline">{{ datos.length }}</div>
                  <div class="caption">Usuarios con registros</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-data-table
            :headers="headers"
            :items="datos"
            :items-per-page="15"
            class="elevation-1"
          >
            <template v-slot:item.total="{ item }">
              <v-chip color="primary" small>
                {{ item.total }}
              </v-chip>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ReporteMensual',
  data() {
    return {
      fecha_desde: new Date().toISOString().substr(0, 7) + '-01',
      fecha_hasta: new Date().toISOString().substr(0, 10),
      menuFechaDesde: false,
      menuFechaHasta: false,
      datos: [],
      totalRegistros: 0,
      loading: false,
      loadingExcel: false,
      consultado: false,
      headers: [
        { text: 'Usuario', value: 'name' },
        { text: 'Total Registros', value: 'total' },
      ],
    };
  },
  methods: {
    consultar() {
      this.loading = true;
      axios
        .get('/api/reporte/mensual', { params: { fecha_desde: this.fecha_desde, fecha_hasta: this.fecha_hasta } })
        .then((response) => {
          this.datos = response.data.datos;
          this.totalRegistros = response.data.total_registros;
          this.consultado = true;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$alertify.error('Error al consultar el reporte');
        });
    },
    descargarExcel() {
      if (!this.fecha_desde || !this.fecha_hasta) {
        this.$alertify.error('Selecciona un rango de fechas');
        return;
      }

      this.loadingExcel = true;
      axios
        .get('/api/reporte/mensual/export', {
          params: { fecha_desde: this.fecha_desde, fecha_hasta: this.fecha_hasta },
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const desde = this.fecha_desde.replace(/-/g, '');
          const hasta = this.fecha_hasta.replace(/-/g, '');
          link.href = url;
          link.download = `reporte_mensual_${desde}_${hasta}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          this.loadingExcel = false;
        })
        .catch((error) => {
          this.loadingExcel = false;
          this.$alertify.error('Error al descargar el reporte');
        });
    },
  },
};
</script>
